// Expense type in advance report is free text, so fuel rows are detected by keywords.
// Fuel for vehicle analytics comes only from the imported fuel file.
const FUEL_KEYWORDS = [
  'топлив',
  'дизел',
  'бензин',
  'солярк',
  'заправ',
  'паливо',
  'paliw',
  'tankow',
  'benzyn',
  'olej napędowy',
  'diesel',
  'fuel',
  'adblue',
  'ad blue',
  'petrol',
]

const FUEL_SHORT_CODES = ['on', 'дт']

export function isFuelExpense(type?: string | null): boolean {
  if (!type) return false
  const value = type.toLowerCase().trim()
  if (FUEL_KEYWORDS.some(keyword => value.includes(keyword))) return true
  return value.split(/[^\p{L}]+/u).some(word => FUEL_SHORT_CODES.includes(word))
}
